// chat-signalr.service.ts
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AccountsService } from '../../services/identity/accounts.service';
import { BaseSignalrService } from '../../services/signalr/base-signalr';
import { Message } from '../type/message.type';

export interface ConversationStartedEvent {
    groupId: string;
    initiatorId: string;
    message: string;
}

@Injectable({
    providedIn: 'root',
})
export class ChatSignalrService extends BaseSignalrService {
    private chatHubBaseUrl: string = environment.microservices.realTime.chatHub.baseUrl;

    // Observables pour événements SignalR
    private readonly messageReceivedSubject = new Subject<Message>();
    private readonly conversationStartedSubject = new Subject<ConversationStartedEvent>();

    readonly messageReceived$: Observable<Message> = this.messageReceivedSubject.asObservable();
    readonly conversationStarted$: Observable<ConversationStartedEvent> = this.conversationStartedSubject.asObservable();

    constructor(protected readonly accountsService: AccountsService) {
        super(accountsService);
        this.hubBaseUrl = this.apiBaseUrl + this.chatHubBaseUrl;
    }

    override async startConnection(): Promise<void> {
        await super.startConnection();

        this.hubConnection.on('ConversationStarted', (groupId: string, initiatorId: string, message: string) => {
            this.joinChatGroup(groupId);
            this.conversationStartedSubject.next({ groupId, initiatorId, message });
        });

        this.hubConnection.on('ReceiveMessage', (message: Message) => {
            this.messageReceivedSubject.next(message);
        });
    }

    override async stopConnection(): Promise<void> {
        await super.stopConnection();
        // Do not complete Subjects here; allows reconnection and further emissions.
        // this.messageReceivedSubject.complete();
        // this.conversationStartedSubject.complete();
    }

    public sendMessage(groupId: string, message: string): void {
        super.sendMessage('SendMessage', groupId, message);
    }

    public startConversation(targetUserId: string, message: string): void {
        super.sendMessage('StartConversation', targetUserId, message);
    }

    public joinGroupReady(groupId: string, message: string, initiatorId: string): void {
        super.sendMessage('JoinGroupReady', groupId, message, initiatorId);
    }
}
